import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";

import SubscribedView from "./SubscribedView";
import UnsubscribedView from "./UnsubscribedView";

export default function Autopilot() {
  const { isAutopilotPlan } = useContext(SubscriptionContext);

  if (!isAutopilotPlan) {
    return <UnsubscribedView />;
  }

  return <SubscribedView />;
}
